import { withInstall } from '@hd-front-end/utils'
import Result from './src/result.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElResult: SFCWithInstall<typeof Result> = withInstall(Result)

export default ElResult

export * from './src/result'
